import { ChevronRight } from 'lucide-react';

const STAGES = [
  { key: 'all', label: 'Ranked Universe', sub: 'positive EBIT & EV', countKey: 'eligible' },
  { key: '1', label: 'Stage 1 · Quality + Value', sub: 'top 20% combined rank', countKey: 'stage1' },
  { key: '2', label: 'Stage 2 · Graham ≥ 4/5', sub: 'deep-value price', countKey: 'stage2' },
  { key: 'elite', label: 'Stage 3 · F-Score ≥ 7', sub: 'financial health · ELITE', countKey: 'stage3' },
];

export function MegaTierFunnel({ counts = {}, stage, onStage }) {
  return (
    <div className="flex flex-wrap items-stretch gap-2" data-testid="mega-tier-funnel">
      {STAGES.map((s, i) => {
        const active = stage === s.key;
        return (
          <div key={s.key} className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => onStage(s.key)}
              data-testid={`mega-tier-stage-${s.key}`}
              className={`text-left rounded-lg border px-3 py-2 transition-colors duration-150 min-w-[150px]
                ${active
                  ? 'border-amber-500 bg-amber-500/10 ring-1 ring-amber-500/40'
                  : 'border-border bg-card hover:border-amber-500/50'}`}
            >
              <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{s.label}</div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl font-bold font-mono" data-testid={`mega-tier-count-${s.key}`}>
                  {counts[s.countKey] ?? '—'}
                </span>
                <span className="text-[11px] text-muted-foreground">{s.sub}</span>
              </div>
            </button>
            {i < STAGES.length - 1 && <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0" />}
          </div>
        );
      })}
    </div>
  );
}
